export default __webpack_public_path__ + "static/media/tinkercad-download.477027b7.png";